import React from "react";
import { Link } from "react-router-dom";

import { useProfile } from "app/context";
import { Trans } from "app/utils";

import styles from "./not-found.module.scss";

const Forbidden: React.FC = () => {
  const { profile } = useProfile();

  return (
    <div className={styles.container}>
      <h1>
        <Trans>Access Forbidden</Trans>
      </h1>
      <hr />
      <p>
        <Trans>
          Uh oh! The page you were looking for cannot be accessed.
          Make sure you are allowed to access the resource.
          Please contact support with any question.
        </Trans>

        <br /><br />

        {
          profile.id
            ? <Link to="/"><Trans>Return home</Trans></Link>
            : <Link to="/login"><Trans>Sign in</Trans></Link>
        }
      </p>
    </div>
  );
};

export default Forbidden;
